var graphsData = $("#graphs-data")
if (graphsData.length > 0) {
  $.getJSON(graphsData.data("url"), function (data, status) {
    if (data !== null && status === "success") {
      $("#processing-animation").hide()
      $("#credit-generation-charts").show()

      var lcfsByQuarter = $("#lcfs-by-quarter")
      new Chart(lcfsByQuarter, {
        type: "bar",
        data: {
          labels: data.lcfs_quarters,
          datasets: [
            {
              label: "Quarterly aggregate LCFS credits",
              data: data.lcfs_quarter_qty,
              barThickness: 36,
              barPercentage: 0.8,
              categoryPercentage: 0.8,
              backgroundColor: "rgb(124, 181, 236)"
            }
          ]
        },
        options: {
          animation: false,
          maintainAspectRatio: false,
          ticks: {
            precision: 0
          },
          plugins: {
            tooltip: {
              backgroundColor: "rgba(251, 232, 170, .8)",
              xPadding: 16,
              yPadding: 16,
              titleFontSize: 16,
              titleColor: "#3598db",
              bodyColor: "black",
              bodyFontSize: 14,
              cornerRadius: 8,
              displayColors: true
            },
            legend: {
              display: false
            }
          },
          fill: false
        }
      })

      var hourly = $("#hourly")
      new Chart(hourly, {
        type: "bar",
        data: {
          labels: data.hours,
          datasets: [
            {
              label: "Aggregate kWh by time of day",
              data: data.hourly_kwh,
              barThickness: 8,
              barPercentage: 0.8,
              categoryPercentage: 0.8,
              backgroundColor: "rgb(124, 181, 236)"
            }
          ]
        },
        options: {
          animation: false,
          maintainAspectRatio: false,
          ticks: {
            precision: 0
          },
          plugins: {
            tooltip: {
              backgroundColor: "rgba(251, 232, 170, .8)",
              xPadding: 16,
              yPadding: 16,
              titleFontSize: 16,
              titleColor: "#3598db",
              bodyColor: "black",
              bodyFontSize: 14,
              cornerRadius: 8,
              displayColors: true
            },
            legend: {
              display: false
            }
          },
          fill: false
        }
      })

      var kwhByQuarter = $("#kwh-by-quarter")
      new Chart(kwhByQuarter, {
        type: "bar",
        data: {
          labels: data.kwh_quarters,
          datasets: [
            {
              label: "Quarterly aggregate kWh",
              data: data.quarterly_kwh,
              barThickness: 36,
              barPercentage: 0.8,
              categoryPercentage: 0.8,
              backgroundColor: "rgb(124, 181, 236)"
            }
          ]
        },
        options: {
          animation: false,
          maintainAspectRatio: false,
          ticks: {
            precision: 0
          },
          plugins: {
            tooltip: {
              backgroundColor: "rgba(251, 232, 170, .8)",
              xPadding: 16,
              yPadding: 16,
              titleFontSize: 16,
              titleColor: "#3598db",
              bodyColor: "black",
              bodyFontSize: 14,
              cornerRadius: 8,
              displayColors: true
            },
            legend: {
              display: false
            }
          },
          fill: false
        }
      })

      var recsByQuarter = $("#recs-by-quarter")
      new Chart(recsByQuarter, {
        type: "bar",
        data: {
          labels: data.rec_quarters,
          datasets: [
            {
              label: "Quarterly aggregate RECs",
              data: data.rec_quarter_qty,
              barThickness: 36,
              barPercentage: 0.8,
              categoryPercentage: 0.8,
              backgroundColor: "rgb(124, 181, 236)"
            }
          ]
        },
        options: {
          animation: false,
          maintainAspectRatio: false,
          ticks: {
            precision: 0
          },
          plugins: {
            tooltip: {
              backgroundColor: "rgba(251, 232, 170, .8)",
              xPadding: 16,
              yPadding: 16,
              titleFontSize: 16,
              titleColor: "#3598db",
              bodyColor: "black",
              bodyFontSize: 14,
              cornerRadius: 8,
              displayColors: true
            },
            legend: {
              display: false
            }
          },
          fill: false
        }
      })

      return $("#lcfs-anticipated-credits").text(data.lcfs_anticipated_credits_text)
    }
  })
}
